import { lazy } from 'react'
import { registerEditor } from '../editor-registry.js'

const LazyReadOnlyText = lazy(() =>
  import('../../ui/ReadOnlyText.js').then(m => ({ default: m.ReadOnlyText }))
)

registerEditor({
  family: 'text-viewer',
  extensions: [],
  name: 'Text Viewer',
  component: LazyReadOnlyText,
  readOnly: true,
})
